export type TAvailableHeightInput = {
  availableHeight: number;
  maxHeight?: number;
};

export const getPopoverAvailableHeight = ({ availableHeight, maxHeight }: TAvailableHeightInput) => {
  const available = Math.max(0, availableHeight);

  return maxHeight === undefined ? available : Math.min(available, maxHeight);
};
